import React from 'react';
import { MissionContainer, MissionContextType } from '../../../services/types/Missions';

const Context = React.createContext<MissionContextType>({
  data: {} as MissionContainer,
  reload: () => {},
  loading: false,
});

export default Context;
